import React, { useContext } from "react";
import styled from "styled-components";
import { Box, Text, themeGet } from "../..";
import Radio from "../Radio/Radio";
import { RadioGroupContext } from "../RadioGroup";
const StyledBox = styled(Box).withConfig({
  displayName: "ProductSurveyRadioButton__StyledBox",
  componentId: "sc-1g8n4zs-0"
})(["padding:6px ", ";background:", ";border:1px solid ", ";border-radius:11px;"], themeGet("space.2"), themeGet("colors.background.neutral.default"), themeGet("colors.border.default"));
const StyledText = styled(Text).withConfig({
  displayName: "ProductSurveyRadioButton__StyledText",
  componentId: "sc-1g8n4zs-1"
})(["font-style:", ";font-weight:", ";font-size:", ";line-height:", ";color:", ";&:hover{color:", ";}"], themeGet("fontWeights.normal"), themeGet("fontWeights.bold"), themeGet("fontSizes.4"), themeGet("lineHeights.condensed"), themeGet("colors.text.subtle"), themeGet("colors.text.default"));
const StyledSubText = styled(Text).withConfig({
  displayName: "ProductSurveyRadioButton__StyledSubText",
  componentId: "sc-1g8n4zs-2"
})(["padding-top:", ";color:", ";font-size:", ";font-weight:", ";"], themeGet("space.1"), themeGet("colors.text.subtlest"), themeGet("fontSizes.2"), themeGet("fontWeights.normal"));
const Label = styled.label.withConfig({
  displayName: "ProductSurveyRadioButton__Label",
  componentId: "sc-1g8n4zs-3"
})(["font-size:2rem;line-height:1.1;display:grid;grid-template-columns:1em auto;gap:", ";&:hover{& > ", "{& > ", "{color:", ";}& > ", "{color:", ";}}}"], themeGet("space.2"), StyledBox, StyledText, themeGet("colors.text.default"), StyledSubText, themeGet("colors.text.subtle"));
const StyledRadio = styled(Radio).withConfig({
  displayName: "ProductSurveyRadioButton__StyledRadio",
  componentId: "sc-1g8n4zs-4"
})(["--radio-dot-color:", ";--radio-background-color-hover:", ";appearance:none;margin:0;width:", ";height:", ";border:", " solid ", ";border-radius:", ";transform:translate(25%,25%);display:grid;place-content:center;&::before{content:\"\";width:", ";height:", ";border-radius:", ";transform:scale(0);box-shadow:inset 1em 1em ", ";transition:120ms transform linear;}&:hover{background-color:var(--radio-background-color-hover);}&:checked{&::before{transform:scale(1);}& + ", "{& > ", "{color:", ";}& > ", "{color:", ";}}background-color:var(--radio-dot-color);}"], themeGet("colors.background.brand.bold.default"), themeGet("colors.background.input.hovered"), themeGet("space.4"), themeGet("space.4"), themeGet("space.1"), themeGet("colors.border.default"), themeGet("radii.4"), themeGet("space.2"), themeGet("space.2"), themeGet("radii.4"), themeGet("colors.elevation.surface.default"), StyledBox, StyledText, themeGet("colors.text.default"), StyledSubText, themeGet("colors.text.subtle"));
const ProductSurveyRadioButton = props => {
  const {
    value,
    subText
  } = props;
  const radioGroupContext = useContext(RadioGroupContext);
  const handleOnChange = e => {
    (radioGroupContext === null || radioGroupContext === void 0 ? void 0 : radioGroupContext.onChange) && radioGroupContext.onChange(e);
  };
  const name = (radioGroupContext === null || radioGroupContext === void 0 ? void 0 : radioGroupContext.name) || "productsurveyradio";
  return /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement(StyledRadio, {
    type: "radio",
    name: name,
    value: value,
    onChange: handleOnChange
  }), /*#__PURE__*/React.createElement(StyledBox, null, /*#__PURE__*/React.createElement(StyledText, {
    as: "p"
  }, value), subText && /*#__PURE__*/React.createElement(StyledSubText, {
    as: "p"
  }, subText)));
};
ProductSurveyRadioButton.displayName = "ProductSurveyRadioButton";
export default ProductSurveyRadioButton;